import React from 'react'
import { Clock } from 'lucide-react'
import { Work } from '../../types'
import { getStatusLabel } from '../../utils/getStatusLabel'
import { InfoTable } from 'components/InfoTable'
import { ReadOnlyBox } from './ReadOnlyBox'
import { leftTdProps, rightTdProps } from './constants'
import { formatInTimeZone } from 'date-fns-tz'
import { WorkStatus } from 'api/typings'
import { useShiftDetailContextValue } from '../../context/ShiftDetailProvider'

const StatusTransition = ({
  label,
  timestamp,
  timezone,
}: {
  label: string
  timezone: string
  timestamp?: string
}) => {
  return (
    <InfoTable.Row
      icon={<Clock size={14} />}
      label={label}
      value={
        <ReadOnlyBox>
          {timestamp
            ? formatInTimeZone(
                timestamp,
                timezone,
                'EE, MMMM d, yyyy, h:mm a z'
              )
            : 'N/A'}
        </ReadOnlyBox>
      }
      leftTdProps={leftTdProps}
      rightTdProps={rightTdProps}
    />
  )
}

const filterOutStatuses: Work['status'][] = [
  WorkStatus.Started,
  WorkStatus.Completed,
]

export const StatusTransitions = ({
  statusTransitions,
}: {
  statusTransitions: Work['statusTransitions']
}) => {
  const {
    state: {
      location: {
        address: { timezone },
      },
    },
  } = useShiftDetailContextValue()

  const rows = Object.entries(statusTransitions)
    .filter(([status]) => !filterOutStatuses.includes(status as Work['status']))
    .map(([status, timestamp]) => {
      const label = getStatusLabel(status as Work['status'])
      const suffixedLabel = `${label} at`
      return (
        <StatusTransition
          key={`worker-row-status-transition-${status}-${timestamp}`}
          label={suffixedLabel}
          timestamp={timestamp}
          timezone={timezone}
        />
      )
    })

  return rows
}
